<template>
  <listing-layout :actionBar="true">
    <div slot="heading" class="d-flex justify-content-between align-items-center mb-3">
      <h1 class="h2 mb-0">Active Drafts</h1>
    </div>

    <div slot="content">

      <div role="alert" class="alert alert-success mt-3" v-if="success">{{ success }}</div>
      <div role="alert" class="alert alert-warning mt-3" v-else-if="errors">{{ errors }}</div>

      <div class="active-drafts" v-if="loaded">
        <div class="drafts" v-if="applications.length > 0">
          <div class="draft" v-for="application in applications" :key="application.id">
            <div class="draft_header table table-bordered p-3 bg-lighter justify-content-between align-items-center d-flex">
              <div class="draft-info">
                <div class="d-flex flex-wrap align-content-center">
                  <h2 class="h5 mr-2">
                    {{ application.draft.name }}
                  </h2>
                  <span :class="['badge mt-0 mb-auto', application.status === 'denied' ? 'alert-danger' : (application.status === 'approved' ? 'alert-success' : 'alert-warning')]">{{ application.status }}</span>
                </div>

                <div class="dates d-flex">
                  <div class="start_date mr-3">
                    <span class="font-weight-bolder">Start Date: </span> {{ application.draft.start_date }}
                  </div>
                  <div class="finish_date">
                    <span class="font-weight-bolder">Finish Date: </span> {{ application.draft.end_date }}
                  </div>
                </div>
              </div>
              <button
                class="btn-default btn-small btn btn-sm btn-outline-primary btn-cancel_application"
                v-on:click="cancelApplication(application.id)"
              >Cancel</button>
            </div>
          </div>
        </div>
        <div v-else class="alert alert-warning rounded-0 mb-0">There are no results.</div>
      </div>
      <div class="bg-white rounded mb-4 p-3 p-sm-4 flex-grow-1 mr-lg-3" v-else>
        <div class="text-center p-2">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    </div>
  </listing-layout>
</template>

<script>
import listingLayout from '@/components/ListingLayout'
import axios from "axios"

export default {
  components: {
    'listing-layout': listingLayout
  },
  name: "ActiveDrafts",
  data() {
    return {
      success: localStorage.getItem("judge-app-status"),
      errors: '',
      loaded: false,
      applications: [],
      judgeId: null
    }
  },
  mounted() {
    this.judgeId = this.$route.params.slug
    axios.get(`${this.$api}/judges/${this.judgeId}/active-drafts`).then((response) => {
      if (response.data.status === 'success') {
        this.errors = ''
        this.applications = response.data.data
        this.loaded = true
      } else if (response.data.status === 'invalid_user') {
        this.$router.push({ name: 'Judges Dashboard' })
      } else {
        this.errors = 'Unable to receive data from the server. Please reload the page.'
      }
    })
    localStorage.removeItem("judge-app-status")
  },
  methods: {
    cancelApplication(applicationId) {
      if (!confirm('Are you sure you want to cancel this application?')) {
        return
      }

      axios.delete(`${this.$api}/judges/${this.judgeId}/drafts/application/${applicationId}/cancel`).then((response) => {
        if (response.data.status === 'success') {
          // Done
          localStorage.setItem("judge-app-status", 'The application has been cancelled.')
          this.errors = ''
          location.reload()
        } else if (response.data.status === 'application_not_found' || response.data.status === 'forbidden') {
          this.success = ''
          this.errors = 'You cannot cancel this application.'
        } else {
          this.success = ''
          this.errors = 'Something went wrong.'
        }
      }).catch(() => {
        this.success = ''
        this.errors = 'There was a server error. Please try again later.'
      })
    }
  }
}
</script>

<style>
.btn-cancel_application {
  max-width: 110px;
  min-width: 80px;
}

@media (max-width: 767px) {

  .draft_header {
    flex-direction: column;
    align-items: flex-start !important;
  }

  .draft-info {
    margin-bottom: 6px;
  }
}

@media (max-width: 550px) {

  .draft-info .dates {
    flex-direction: column;
    align-items: flex-start !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Judges/ExpressionOfInterest/ActiveDrafts.vue